import request from "../helpers/request";
import { USER_ROLE } from "./specialistService";

export const register = async (data) => {
  const response = await request.post(`/api/auth/register`, data);
  return response.data;
};

const unwrapAuthResponse = (payload, fallbackMessage) => {
  if (payload?.status === false) {
    const error = new Error(payload.message || fallbackMessage);
    error.response = { data: payload };
    throw error;
  }
  return payload;
};

/** POST /api/auth/login cavabını token, guard və istifadəçi məlumatına çevirir. */
export const normalizeLoginResponse = (payload) => {
  const raw = payload?.data && typeof payload.data === "object" ? payload.data : payload ?? {};
  const nested =
    raw?.user && typeof raw.user === "object"
      ? raw.user
      : raw?.specialist && typeof raw.specialist === "object"
        ? raw.specialist
        : null;
  const source = nested ? { ...raw, ...nested } : raw;
  const token = String(raw?.token || raw?.access_token || source?.token || "").trim();
  const guard = String(source?.guard || raw?.guard || source?.role || "").toLowerCase();
  const isSpecialist = guard === USER_ROLE.SPECIALIST || guard === "specialist";
  const name = String(source?.name || source?.full_name || "").trim();

  return {
    token,
    guard: isSpecialist ? USER_ROLE.SPECIALIST : guard || USER_ROLE.USER,
    role: isSpecialist ? USER_ROLE.SPECIALIST : USER_ROLE.USER,
    message: payload?.message || "",
    user: {
      name,
      full_name: source?.full_name || name,
      email: source?.email || "",
      guard: isSpecialist ? USER_ROLE.SPECIALIST : source?.guard || guard,
    },
  };
};

export const login = async (data) => {
  const response = await request.post(`/api/auth/login`, data);
  const payload = unwrapAuthResponse(response.data, "Giriş uğursuz oldu");
  const normalized = normalizeLoginResponse(payload);
  if (!normalized.token) {
    const error = new Error(payload?.message || "Giriş uğursuz oldu. Cavabda token yoxdur.");
    error.response = { data: payload };
    throw error;
  }
  return normalized;
};

/** Şifrə bərpa kodu göndər: POST /api/auth/forgot-password */
export const forgotPassword = async (data) => {
  const response = await request.post(`/api/auth/forgot-password`, data);
  return unwrapAuthResponse(response.data, "Unable to send reset link");
};

/** Şifrəni yenilə: POST /api/auth/reset-password */
export const resetPassword = async ({ email, token, password, password_confirmation }) => {
  const response = await request.post(`/api/auth/reset-password`, {
    email,
    token,
    password,
    password_confirmation,
  });
  return unwrapAuthResponse(response.data, "Password reset failed");
};

/** Çıxış: POST /api/auth/logout (token header-da göndərilir) */
export const logoutApi = async () => {
  const response = await request.post(`/api/auth/logout`);
  return response.data;
};

export const authUser = async (token) => {
  const response = await request.get("/account/me/", {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  return response.data;
};

/** Profil məlumatları: GET /api/cabinet/profile/me */
export const getProfileMe = async () => {
  const response = await request.get("/api/cabinet/profile/me");
  return response.data;
};

/** Profil yenilə (cabinet – daxil olan istifadəçi): PUT /api/cabinet/profile/update */
export const updateProfileCabinet = async (data) => {
  const response = await request.put("/api/cabinet/profile/update", data);
  return response.data;
};

/** Şifrə yenilə (cabinet): PUT /api/cabinet/profile/update-password */
export const updatePasswordCabinet = async (data) => {
  const response = await request.put("/api/cabinet/profile/update-password", data);
  return response.data;
};

/** Profil yenilə (company): PUT /api/company/profile/update */
export const updateProfileCompany = async (data) => {
  const response = await request.put("/api/company/profile/update", data);
  return response.data;
};

/** Şifrə yenilə (company): PUT /api/company/profile/update-password */
export const updatePasswordCompany = async (data) => {
  const response = await request.put("/api/company/profile/update-password", data);
  return response.data;
};

export const updateUser = async (token, userData) => {
  const response = await request.patch("/account/user/", userData, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  return response.data;
};

export const setUserPassword = async (token, passwordData) => {
  const response = await request.post("/account/user-set-password/", passwordData, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  return response.data;
};
